import { render, staticRenderFns } from "./CInfo.vue?vue&type=template&id=68fec326&scoped=true"
import script from "./CInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CInfo.vue?vue&type=style&index=0&id=68fec326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fec326",
  null
  
)

export default component.exports